import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const CreateNewWalletIllustration = (props: SVGProps) => {
  const { className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      width="158"
      height="122"
      viewBox="0 0 158 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g clip-path="url(#clip0_22_6120)">
        <path
          d="M14.8637 25.4289C3.81338 25.1701 0.871441 31.2113 0.140869 35.2376C1.90341 39.8471 6.37202 43.133 11.5941 43.133H73.0866V45.2887H11.5941C7.42037 45.2887 3.65285 43.5032 1.01887 40.6563C1.40872 41.3181 1.90014 41.9307 2.48656 42.4647C3.35145 43.251 4.28842 43.9619 5.27125 44.5778C5.57265 44.7776 8.74392 46.7793 13.9922 46.7793H85.3589V25.4257H14.8637V25.4289Z"
          fill="currentColor"
        />
        <path
          d="M73.0834 44.624V45.2891H11.5941C6.84706 45.2891 2.63071 42.9827 0 39.4314V105.225C0 112.741 5.76267 118.87 13.1175 119.182C13.3993 119.195 13.6876 119.201 13.9791 119.201H95.5902V44.6273H73.0834V44.624Z"
          fill="white"
        />
        <path
          d="M152.001 37.8014C152.001 25.5815 142.098 15.6746 129.875 15.6746C117.651 15.6746 107.748 25.5815 107.748 37.8014V43.1054C107.748 55.3253 117.658 65.2355 129.875 65.2355C142.098 65.2355 152.001 55.3285 152.001 43.1054V37.8014Z"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M152.001 45.2872C152.001 57.5071 142.098 67.4173 129.875 67.4173C117.658 67.4173 107.748 57.5104 107.748 45.2872C107.748 33.0673 117.658 23.1604 129.875 23.1604C142.091 23.1604 152.001 33.0673 152.001 45.2872Z"
          fill="white"
          stroke="white"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M129.878 27.6655C120.141 27.6655 112.249 35.5544 112.249 45.2877C112.249 55.021 120.141 62.9099 129.878 62.9099C139.614 62.9099 147.5 55.021 147.5 45.2877C147.5 35.5544 139.605 27.6655 129.878 27.6655Z"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M129.875 94.8307C117.537 94.8307 107.496 84.7895 107.496 72.4517V66.8888C107.496 54.551 117.534 44.5098 129.875 44.5098C142.216 44.5098 152.254 54.5478 152.254 66.8888V72.4517C152.254 84.7928 142.216 94.8307 129.875 94.8307Z"
          fill="currentColor"
        />
        <path
          d="M129.875 45.3339C141.764 45.3339 151.435 55.0049 151.435 66.8939V72.4567C151.435 84.3457 141.764 94.0168 129.875 94.0168C117.986 94.0168 108.315 84.3457 108.315 72.4567V66.8939C108.315 55.0049 117.986 45.3339 129.875 45.3339ZM129.875 43.6958C117.069 43.6958 106.677 54.0843 106.677 66.8939V72.4567C106.677 85.2696 117.065 95.6548 129.875 95.6548C142.684 95.6548 153.073 85.2663 153.073 72.4567V66.8939C153.073 54.0843 142.691 43.6958 129.875 43.6958Z"
          fill="currentColor"
        />
        <path
          d="M152.001 72.3251C152.001 84.5449 142.098 94.4551 129.875 94.4551C117.658 94.4551 107.748 84.5482 107.748 72.3251C107.748 60.1052 117.658 50.1982 129.875 50.1982C142.091 50.1982 152.001 60.1052 152.001 72.3251Z"
          fill="black"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M129.878 55.8245C120.761 55.8245 113.37 63.2121 113.37 72.3262C113.37 81.4403 120.761 88.8279 129.878 88.8279C138.989 88.8279 146.38 81.4403 146.38 72.3262C146.38 63.2121 138.989 55.8245 129.878 55.8245Z"
          stroke="white"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M130.52 120.21C118.772 120.21 109.212 110.651 109.212 98.8994V93.5954C109.212 81.8473 118.772 72.2876 130.52 72.2876C142.268 72.2876 151.828 81.8473 151.828 93.5954V98.8994C151.828 110.651 142.268 120.21 130.52 120.21Z"
          fill="white"
        />
        <path
          d="M130.52 73.1053C141.816 73.1053 151.009 82.2981 151.009 93.5941V98.8981C151.009 110.197 141.816 119.39 130.52 119.39C119.224 119.39 110.031 110.197 110.031 98.8981V93.5941C110.031 82.2981 119.224 73.1053 130.52 73.1053ZM130.52 71.4673C118.303 71.4673 108.393 81.3742 108.393 93.5941V98.8981C108.393 111.118 118.303 121.028 130.52 121.028C142.736 121.028 152.647 111.121 152.647 98.8981V93.5941C152.647 81.3742 142.743 71.4673 130.52 71.4673Z"
          fill="white"
        />
        <path
          d="M152.647 98.8966C152.647 111.116 142.743 121.027 130.52 121.027C118.303 121.027 108.393 111.12 108.393 98.8966C108.393 86.6767 118.303 76.7698 130.52 76.7698C142.736 76.7698 152.647 86.6767 152.647 98.8966Z"
          fill="currentColor"
        />
        <path
          d="M130.523 81.2749C120.787 81.2749 112.895 89.1638 112.895 98.8971C112.895 108.63 120.787 116.519 130.523 116.519C140.25 116.519 148.146 108.63 148.146 98.8971C148.146 89.1638 140.25 81.2749 130.523 81.2749Z"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M109.68 15.0241C109.68 15.0241 85.8208 -9.22289 58.5201 16.8079"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M58.8119 6.54655L57.5342 17.4645L68.0808 18.2722"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M157.413 6.3042L149.698 14.2029"
          stroke="white"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M143.051 11.4391L144.889 0.133301"
          stroke="white"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M0 81.4597H33.4916"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M33.4 83.3048C34.4204 83.3048 35.2477 82.4776 35.2477 81.4571C35.2477 80.4366 34.4204 79.6094 33.4 79.6094C32.3795 79.6094 31.5522 80.4366 31.5522 81.4571C31.5522 82.4776 32.3795 83.3048 33.4 83.3048Z"
          fill="black"
        />
        <path
          d="M0 91.3171H34.5072V107.999"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M32.6594 107.905C32.6594 108.924 33.4883 109.753 34.5071 109.753C35.526 109.753 36.3549 108.924 36.3549 107.905C36.3549 106.886 35.526 106.057 34.5071 106.057C33.4883 106.057 32.6594 106.886 32.6594 107.905Z"
          fill="black"
        />
        <path
          d="M0 71.5952H34.5072V54.9165"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M36.3549 55.0079C36.3549 53.989 35.526 53.1602 34.5071 53.1602C33.4883 53.1602 32.6594 53.989 32.6594 55.0079C32.6594 56.0267 33.4883 56.8556 34.5071 56.8556C35.526 56.8556 36.3549 56.0267 36.3549 55.0079Z"
          fill="black"
        />
        <path
          d="M65.6629 98.1169C74.7947 98.1169 82.1974 90.7141 82.1974 81.5824C82.1974 72.4506 74.7947 65.0479 65.6629 65.0479C56.5312 65.0479 49.1284 72.4506 49.1284 81.5824C49.1284 90.7141 56.5312 98.1169 65.6629 98.1169Z"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M73.9121 81.679H57.5906"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M65.7515 73.7734V89.5872"
          stroke="black"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
        <path
          d="M95.6622 103.247V119.199H64.418"
          stroke="currentColor"
          stroke-width="1.63805"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_6120">
          <rect width="158" height="121.026" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
